import { StyleGrid } from '../style'
import LabTestCard from '@commons/cards/labTest'
import { InstituteLabTest } from '@apis'
import { useSelector } from 'react-redux'
import { Fragment, useEffect, useState } from 'react'
import LabTestCardLoader from '@commons/cards/labTest/loader'
import Empty from '@commons/empty'
import useInstituteLabTestActions from '@hooks/useInstituteLabTestActions'
import Row from '@components/row'
import Button from '@components/button'
const Tests = () => {
  const {
    items: labTests,
    loading,
    totalPages,
  } = useSelector((state: any) => state.instituteLabTests)
  const { data: user } = useSelector((state: any) => state.user)
  const [params, setParams] = useState({
    page: 1,
    limit: 6,
    userId: user?.id,
    isPackage: false,
  })
  const { handleClick } = useInstituteLabTestActions({
    selector: 'instituteLabTests',
    type: 'Normal',
  })
  const fetchData = async (params, action = 'set') => {
    await InstituteLabTest.list({
      params,
      state: 'instituteLabTests',
      action,
    }).catch(() => {})
  }

  const onLoadMore = async () => {
    const updateParams = {
      ...params,
      page: params?.page + 1,
    }
    setParams(updateParams)
    await fetchData(updateParams, 'append')
  }
  useEffect(() => {
    if (!labTests?.length) {
      fetchData(params)
    }
  }, [])

  return (
    <>
      {!!loading ? (
        <StyleGrid>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return (
                <Fragment key={index}>
                  <LabTestCardLoader />
                </Fragment>
              )
            })}
        </StyleGrid>
      ) : (
        <>
          {!!labTests?.length ? (
            <StyleGrid onClick={handleClick}>
              {labTests?.map((labTest: any) => {
                return (
                  <Fragment key={labTest?.id}>
                    <LabTestCard labTest={labTest} />
                  </Fragment>
                )
              })}
            </StyleGrid>
          ) : (
            <Empty />
          )}
        </>
      )}
      {params?.page < totalPages && (
        <Row justifyContent="center">
          <Button title="Load More" onClick={onLoadMore} />
        </Row>
      )}
    </>
  )
}

export default Tests
